export default __webpack_public_path__ + "static/media/study-session-group.a04df755.png";